import { render, staticRenderFns } from "./HistoryQuestionShow.vue?vue&type=template&id=5bbfe6ca&scoped=true&"
import script from "./HistoryQuestionShow.vue?vue&type=script&lang=js&"
export * from "./HistoryQuestionShow.vue?vue&type=script&lang=js&"
import style0 from "./HistoryQuestionShow.vue?vue&type=style&index=0&id=5bbfe6ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbfe6ca",
  null
  
)

export default component.exports